import { render } from "./RntrcSolicitacaoDetalhe.vue?vue&type=template&id=19baf486&scoped=true"
import script from "./RntrcSolicitacaoDetalhe.vue?vue&type=script&lang=ts"
export * from "./RntrcSolicitacaoDetalhe.vue?vue&type=script&lang=ts"

import "./RntrcSolicitacaoDetalhe.vue?vue&type=style&index=0&id=19baf486&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-19baf486"

export default script